module.exports = __webpack_public_path__ + "img/logo.14110a0d.png";